import script from "./ModalFotosEncontro.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalFotosEncontro.vue?vue&type=script&setup=true&lang=js"

import "./ModalFotosEncontro.vue?vue&type=style&index=0&id=1e2446c4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e2446c4"]])

export default __exports__